import ClientLayout from '@/components/feature/ClientLayout';
import { useClientProject } from '@/hooks/useClientProject';
import ClientPaymentsPanel from '@/pages/client/payments/ClientPaymentsPanel';
import { useTranslation } from 'react-i18next';

export default function ClientPayments() {
  const { t } = useTranslation();
  const { selectedProject, projectId, projectCode, loading } = useClientProject();

  return (
    <ClientLayout title="Payments">
      <div className="px-4 lg:px-8 pt-5 pb-10 max-w-3xl">

        {/* Header */}
        <div className="mb-5">
          <h2 className="text-[15px] font-bold text-[#1A1A1A]">{t('client.payments.paymentSchedule')}</h2>
          <p className="text-[#9CA3AF] text-xs mt-0.5">
            {selectedProject?.project_name ?? t('client.portal.yourProject')} · Japan Homes
          </p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-16">
            <i className="ri-loader-4-line animate-spin text-[#E8621A] text-2xl"></i>
          </div>
        ) : projectId ? (
          <ClientPaymentsPanel
            projectId={projectId}
            projectCode={projectCode ?? undefined}
            projectName={selectedProject?.project_name ?? undefined}
          />
        ) : (
          <div className="text-center py-12">
            <p className="text-[#9CA3AF] text-sm">{t('client.portal.noProjectLinked')}</p>
          </div>
        )}
      </div>
    </ClientLayout>
  );
}